<h3 class="row">
    <span class="item">
        <span>Fuites</span>
    </span>
</h3>
<tui-axes class="axes" [horizontalLines]="12" [axisYLabels]="['0', '20', '40', '60']">
    <tui-bar-chart [max]="60" [value]="[fuitesList]" [tuiHintContent]="hint" />
</tui-axes>

<ng-template #hint let-data>
    <app-telesuivi-graphique-hint-fuites [index]="data" [fuitesList]="fuitesList" [dateList]="dateList" />
</ng-template>